// Import the functions you need from the SDKs you need
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import "firebase/messaging";
import { removeUserFirebaseId } from "components/Notification/Notifications";

let messaging = null;
let messagingSupported = false;
let messagingInitPromise = null;

// Initialize Firebase and check messaging support
if (!window.location.href.includes("karsten-portal-b2b-test")) {
  try {
    const firebaseConfig = {
      apiKey: "AIzaSyD2qNKXKBogThM5E80KucRfVSE8kyJAC_w",
      authDomain: "portal-pushnotifications.firebaseapp.com",
      projectId: "portal-pushnotifications",
      storageBucket: "portal-pushnotifications.appspot.com",
      messagingSenderId: "997156892547",
      appId: "1:997156892547:web:1b259b70604adfd02250b6",
      measurementId: "G-RN6T9XHVQT",
    };

    // Initialize Firebase
    initializeApp(firebaseConfig);

    // Check if messaging is supported before initializing
    messagingInitPromise = isSupported()
      .then((supported) => {
        messagingSupported = supported;
        if (supported) {
          try {
            messaging = getMessaging();
          } catch (error) {
            console.warn("Firebase Messaging initialization failed:", error);
            messagingSupported = false;
          }
        } else {
          console.log("Firebase Messaging não é suportado neste ambiente (ex: Webview Instagram)");
        }
        return supported;
      })
      .catch((error) => {
        console.warn("Erro ao verificar suporte do Firebase Messaging:", error);
        messagingSupported = false;
        return false;
      });
  } catch (error) {
    console.warn("Erro ao inicializar Firebase:", error);
    messagingInitPromise = Promise.resolve(false);
  }
} else {
  messagingInitPromise = Promise.resolve(false);
}

export const getNotificationsPermission = async () => {
  try {
    if (window.location.href.includes("karsten-portal-b2b-test")) {
      return new Promise((resolve, reject) => {
        reject();
      });
    }

    // Check if Service Worker is supported
    if (!('serviceWorker' in navigator)) {
      console.log("Service Worker não é suportado neste ambiente (ex: Webview Instagram)");
      return new Promise((resolve, reject) => {
        reject(new Error("Service Worker não suportado"));
      });
    }

    // Wait for messaging initialization if still in progress
    if (messagingInitPromise) {
      await messagingInitPromise;
    }

    // Check if messaging is supported and initialized
    if (!messagingSupported || !messaging) {
      // Double check with isSupported in case initialization is still pending
      const supported = await isSupported().catch(() => false);
      if (!supported || !messaging) {
        console.log("Firebase Messaging não é suportado neste ambiente");
        return new Promise((resolve, reject) => {
          reject(new Error("Firebase Messaging não suportado"));
        });
      }
    }

    const firebaseID = localStorage.getItem("userFirebaseId")

    const removeFirebaseId = () => {
      localStorage.removeItem("userFirebaseId");
      return removeUserFirebaseId(firebaseID)
    }

    if(firebaseID){
      removeFirebaseId()
    }

    const swRegistration = await navigator.serviceWorker.register('./firebase-messaging-sw.js');
    const getFirebaseToken = await getToken(messaging, {
      serviceWorkerRegistration: swRegistration,
      vapidKey:"BPIXc5zQshSkhb0Eu25c9rOoio3upUijWLylFwjhwMxq4rlMJuSMuqoGZwmAdthI4xHeSt8-dgKzJY85YJt6TPU",
    }).then((res)=>{
      return res
    }).catch((err)=>{
      return err
    });
    return getFirebaseToken
  } catch (error) {
    console.warn("Erro ao obter permissão de notificações:", error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};

export const onMessageListener = (userLoggedIn) => {
  try {
    if (
      window.location.href.includes("karsten-portal-b2b-test") ||
      !userLoggedIn
    ) {
      return new Promise((resolve, reject) => {
        reject();
      });
    }

    // Wait for messaging initialization if still in progress, then check availability
    return Promise.resolve(messagingInitPromise || Promise.resolve())
      .then(() => {
        // Check if messaging is available
        if (!messaging) {
          console.log("Firebase Messaging não está disponível");
          throw new Error("Firebase Messaging não disponível");
        }

        return new Promise((resolve, reject) => {
          try {
            onMessage(messaging, (payload) => {
              console.log("payload", payload);
              resolve(payload);
            });
          } catch (error) {
            console.warn("Erro ao configurar listener de mensagens:", error);
            reject(error);
          }
        });
      })
      .catch((error) => {
        console.warn("Erro ao inicializar listener de mensagens:", error);
        return Promise.reject(error);
      });
  } catch (error) {
    console.warn("Erro ao inicializar listener de mensagens:", error);
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
};
